export const TITULO_PAGINA = 'Upgrade do plano'

export const LABEL_BOTAO_ULTIMA_ETAPA = 'Assinar plano anual'

export const BASE_PROPRIEDADE_ASSINATURA_UPGRADE = 'assinatura_id'

export const BASE_PROPRIEDADE_BRINDE_UPGRADE = 'brinde'

export const BASE_PROPRIEDADE_ENTREGA_UPGRADE = 'entrega'

export const BASE_PROPRIEDADE_PAGAMENTO_UPGRADE = 'pagamento'

export const BASE_PROPRIEDADE_CUPONS_UPGRADE = 'cupons'

export const BASE_PROPRIEDADE_PAGAMENTO_CARTAO_UPGRADE = 'cartao_credito'

export const SUCESSO_FAZER_UPGRADE_CARTAO = 'Upgrade de plano realizado com sucesso!'

export const SUCESSO_FAZER_UPGRADE_PIX = 'O Upgrade de plano será realizado assim que você fizer o pagamento do seu pix.'

export const BASES_OBRIGATORIAS_UPGRADE = [
  BASE_PROPRIEDADE_ASSINATURA_UPGRADE,
  BASE_PROPRIEDADE_BRINDE_UPGRADE,
  BASE_PROPRIEDADE_ENTREGA_UPGRADE,
  BASE_PROPRIEDADE_PAGAMENTO_UPGRADE
]

export const BASES_OPCIONAIS_UPGRADE = [ BASE_PROPRIEDADE_CUPONS_UPGRADE ]
